

export const buildLocale = (locale?: string) => {
    return !!locale ? (locale === "en" ? "" : `/${locale}`) : "";
};

export const buildLocalePrefix = (locale?: string) => {
    return !!locale ? (locale === "en" ? "" : `/${locale}`) : "";
};